<template>
  <div>
    <div class="container">
      <van-image width="100%" src="static/img/join/top.png" />
      <div class="main">
        <van-image width="100%" radius="8px" src="static/img/join/join-first.png" />

        <chain />

        <div class="block1">
          <van-form @submit="onSubmit">
            <div class="form-item">
              <van-field class="form-input" v-model="form1.name" name="姓名" label="姓名" label-width="95" placeholder="请输入您的姓名" :rules="[{ required: true, message: '请输入您的姓名' }]" />
            </div>
            <div class="form-item">
              <van-field class="form-input" v-model="form1.phone" name="联系号码" label="联系号码" label-width="95" placeholder="请输入您的联系号码" :rules="[{ required: true, message: '请输入您的联系号码' }]" />
            </div>
            <div class="form-item">
              <van-field class="form-input" right-icon="location" v-model="form1.location" name="城市" label="城市" label-width="95" placeholder="请选择你所在的城市" :rules="[{ required: true, message: '请选择你所在的城市' }]" @click="showLocaSelecter1 = true" />
            </div>
            <van-popup v-model="showLocaSelecter1" round position="bottom">
              <van-cascader columns-num="2" v-model="form1.location" title="请选择所在地区" :options="areaData" @close="showLocaSelecter1 = false;form1.location ='' " @finish="onloaclfin1" />
            </van-popup>

            <div style="width:100%;text-align:center;padding:10px 0;font-size:0.30rem">联系微信: disfake1</div>

            <div class="checkbox">
              <van-checkbox v-model="checked" shape="square" icon-size="15px" checked-color="#FF7941"></van-checkbox>
              <p style="margin-left:10px">自动输入历史信息</p>
              <p class="xieyi" @click="showXieyi = true">{{xieyi}}</p>
            </div>
            <div style="margin-top: 15px;">
              <van-button style="border-radius:8px;font-weight: bold;" block color="#FF7941" native-type="submit">立即加盟</van-button>
            </div>
          </van-form>
        </div>

        <chain />

        <div class="block2">
          <van-image width="228px" radius="8px" src="static/img/join/introduce.png" />
          <van-image style="margin-top:10px" width="255px" radius="8px" src="static/img/join/app.png" />
          <p style="font-size: 15px;font-weight: bold; margin:10px 0 20px">聚亲修谱APP/小程序</p>

          <div class="info-main">
            <van-image style="margin-top:10px" width="44px" src="static/img/join/jvqing.png" />
            <p style="font-siz: 12px;flex:1;padding-left:15px">基于族谱编修而开发的一款集电子族谱、群聊 社区、群活动、宗族人员管理、互助、敬老助 学等功能于一体的社交修谱软件。</p>
          </div>

          <div class="functions">
            <div class="f-item" v-for="(item,index) in functions" :key="index">
              <van-image width="45px" :src="item.img" />
              <p class="f-title">{{item.title}}</p>
              <p class="f-content" v-html="item.content"></p>
            </div>
          </div>

          <div class="slogan">
            <div v-for="(item,index) in slogans" :key="index">{{item.word}}</div>
          </div>

        </div>

        <chain />

        <div class="block3">

          <van-image width="228px" radius="8px" src="static/img/join/revenue-model.png" />
          <div class="revenuslist">
            <div v-for="(item,index) in revenus" :key="index">
              <van-image v-if="item.img" width="100%" :src="item.img" />
              <div class="revenuslist-word">
                <div v-if="item.word" v-html="item.word"></div>
                <div v-if="item.detail" style="font-size:13px;font-weight: bold;margin-top:8px;text-align:left" v-html="item.detail"></div>
              </div>
            </div>
          </div>
        </div>

        <chain />

        <div class="block4">
          <van-image width="228px" src="static/img/join/showGenealogy.png" />

          <div class="example">
            <van-image width="160px" style="flex:1" src="static/img/join/example1.png" />
            <van-image width="160px" style="flex:1" src="static/img/join/example2.png" />
          </div>

          <p style="font-size:15px;font-weight:bold;margin:10px 0 10px">联系印刷族谱</p>

          <van-form @submit="onSubmit">
            <div class="form-item">
              <van-field class="form-input" v-model="form2.name" name="姓名" label="姓名" label-width="95" placeholder="请输入您的姓名" :rules="[{ required: true, message: '请输入您的姓名' }]" />
            </div>
            <div class="form-item">
              <van-field class="form-input" v-model="form2.phone" name="联系号码" label="联系号码" label-width="95" placeholder="请输入您的联系号码" :rules="[{ required: true, message: '请输入您的联系号码' }]" />
            </div>
            <div class="form-item">                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        
              <van-field class="form-input" v-model="form2.number" name="想要印刷的数量" label="想要印刷的数量" label-width="120" placeholder="请输入数字" :rules="[{ required: true, message: '请输入想要印刷的数量' }]" />
            </div>

            <div style="width:100%;text-align:center;padding:10px 0;font-size:0.30rem">联系微信: disfake1</div>

            <div style="margin-top: 15px;">
              <van-button style="border-radius:8px;font-weight: bold;" block color="#FF7941" native-type="submit">提交</van-button>
            </div>
          </van-form>

          <p style="font-size:13px;font-weight:bold;margin:10px 0 10px">前人不修谱·后人寻根苦·今人不修谱·后人不知苦</p>
        </div>

        <chain />

        <div class="block5">
          <van-image width="228px" src="static/img/join/advantage.png" />

          <div class="functions">
            <div class="f-item" v-for="(item,index) in advantages" :key="index">
              <van-image width="45px" :src="item.img" />
              <p class="f-title">{{item.title}}</p>
              <p class="f-content" v-html="item.content"></p>
            </div>
          </div>
        </div>

        <chain />

        <div class="block6">
          <van-image width="228px" src="static/img/join/joinus.png" />

          <p class="origin" v-html="origin"></p>

          <p style="font-size: 15px;font-weight:bold;line-height: 18px;margin-top:10px">全国招商，立即加盟</p>

          <van-form @submit="onSubmit">
            <div class="form-item">
              <van-field class="form-input" v-model="form3.name" name="姓名" label="姓名" label-width="95" placeholder="请输入您的姓名" :rules="[{ required: true, message: '请输入您的姓名' }]" />
            </div>
            <div class="form-item">
              <van-field class="form-input" v-model="form3.phone" name="联系号码" label="联系号码" label-width="95" placeholder="请输入您的联系号码" :rules="[{ required: true, message: '请输入您的联系号码' }]" />
            </div>
            <div class="form-item">
              <van-field class="form-input" right-icon="location" v-model="form3.location" name="城市" label="城市" label-width="95" placeholder="请选择省市" :rules="[{ required: true, message: '请选择你所在的城市' }]" @click="showLocaSelecter2 = true" />
            </div>
            <van-popup v-model="showLocaSelecter2" round position="bottom">
              <van-cascader columns-num="2" v-model="form3.loaction" title="请选择你所在的城市" :options="areaData" @close="showLocaSelecter2 = false;form3.loaction = ''" @finish="onloaclfin2" />
            </van-popup>
            <div class="checkbox">
              <van-checkbox v-model="checked" shape="square" icon-size="15px" checked-color="#FF7941"></van-checkbox>
              <p style="margin-left:10px">自动输入历史信息</p>
              <p class="xieyi" @click="showXieyi = true">{{xieyi}}</p>
            </div>
            <div style="margin-top: 15px;">
              <van-button style="border-radius:8px;font-weight: bold;" block color="#FF7941" native-type="submit">立即加盟</van-button>
            </div>
          </van-form>

          <div class="customer">
            <div class="customer-title">最新资讯客户</div>
            <div class="customer-con">
              <div class="customer-list" v-for="index in 2" :key="index">
                <div class="customer-list-item" v-for="(item,index) in customers" :key="index">
                  <div style="flex:1">{{item.name}}</div>
                  <div style="flex:1">{{item.phone}}</div>
                  <div style="flex:1">{{item.loaction}}</div>
                  <div style="flex:1">{{item.date}}</div>
                </div>
              </div>
            </div>
          </div>

          <van-image width="100%" src="static/img/join/slogan2.png" style="margin-top:20px;" />

          <div class="origin2">
            <div class="customer-title">聚亲现代修谱平台</div>
            <div class="origin2-process">录入族员→版式选择→自动排版→族谱印刷</div>
            <div class="origin2-text" v-html="origin2text"></div>
            <van-image width="65px" src="static/img/join/jqxp.png" />
            <div class="origin2-process">投资有风险，入市须谨慎</div>
          </div>

          <div class="tips">
            <div style="display: flex;flex-direction: column;">
              <van-image width="100px" height="100px" src="static/img/join/code-com.png" />
              <div style="display: flex;align-items: center;justify-content: center;">
                <van-image width="15px" height="15px" src="static/img/join/icon-wx.png" />
                <div class="tips-text" style="margin-left:10px">添加企业微信</div>
              </div>
            </div>
            <div style="display: flex;flex-direction: column;">
              <van-image width="100px" height="100px" src="static/img/join/code.png" />
              <div>
                <div class="tips-text">下载聚亲app</div>
              </div>
            </div>
          </div>

          <div class="com">捷帮电子科技（广州）有限公司</div>

        </div>
      </div>

      <div class="footer" v-if="hideshow">
        <div class="book">
          <van-image width="25px" height="30px" src="static/img/join/book.png" />
          <p>预约</p>
        </div>
        <div class="callus" @click="callPhone">
          <van-image width="220px" radius="8px" src="static/img/join/callus.png" />
        </div>
      </div>
    </div>

    <van-popup v-model="showXieyi" round closeable close-icon="close" :style="{ width: '70%' }">
      <div class="popup-main">
        <div class="popup-title">个人信息授权与隐私政策</div>
        <div v-html="xieyiContent" style="margin-top:7px"></div>
      </div>
    </van-popup>

  </div>
</template>
<script>
import chain from "./components/chain.vue"
export default {
  components: { chain },
  data () {
    return {
      showLocaSelecter1: false,
      showLocaSelecter2: false,
      checked: false,
      xieyi: "《个人信息授权协议》",
      showXieyi: false,
      form1: {
        name: '',
        phone: '',
        loactionID: '',
      },
      form2: {
        name: '',
        phone: '',
        number: '',
      },
      form3: {
        name: '',
        phone: '',
        loaction: '',
        loactionID: '',
      },
      functions: [
        { img: "static/img/join/function1.png", title: "线上族谱", content: "多种样式选择<br>支持家谱导出" },
        { img: "static/img/join/function2.png", title: "线上录入", content: "全体人员参与<br>多端配合录入" },
        { img: "static/img/join/function3.png", title: "宗亲群聊", content: "创建宗亲群组<br>家谱事项沟通" },
        { img: "static/img/join/function4.png", title: "群活动管理", content: "活动举办详情<br>线上线下配合" },
        { img: "static/img/join/function5.png", title: "敬老助学", content: "敬老温暖人心<br>真情助学成长" },
        { img: "static/img/join/function6.png", title: "财务公开", content: "财务公开透明<br>家族全体监督" },
      ],
      slogans: [
        { word: "修族谱" },
        { word: "建祠堂" },
        { word: "聚祭祖" },
        { word: "传文化" },
        { word: "扬考信" },
        { word: "光宗族" },
      ],
      revenus: [
        { img: "static/img/join/model1.png" },
        { word: "加盟服务商" },
        { word: "软件权限<br>软件权限分配" },
        { img: "static/img/join/model2.png" },
        { img: "static/img/join/model3.png" },
        { word: "分销招收合约<br>招收合约商" },
        { word: "修谱软件 " },
        { img: "static/img/join/model4.png" },
        { img: "static/img/join/model5.png" },
        { word: "配套纪念平台", detail: "用户通过平台购买虚拟产 品（花圈、香等）物品可获取佣金" },
      ],
      advantages: [
        { img: "static/img/join/advantages1.png", title: "众人协作", content: "多人参与修谱<br>配合录入校对" },
        { img: "static/img/join/advantages2.png", title: "优化排版", content: "传统创新排版<br>多种排版样式" },
        { img: "static/img/join/advantages3.png", title: "简单易用", content: "高人性化体验<br>减少使用难度" },
        { img: "static/img/join/advantages4.png", title: "隐私安全", content: "专属隐私谱库<br>防止数据泄露" },
        { img: "static/img/join/advantages5.png", title: "全业务链", content: "支持旧谱翻新<br>新谱人员录入" },
        { img: "static/img/join/advantages6.png", title: "省时省力", content: "修谱置于线上<br>减少线下走访" },
        { img: "static/img/join/advantages7.png", title: "多码应用", content: "图文音频视频<br>扫码线上查看" },
        { img: "static/img/join/advantages8.png", title: "广告营销", content: "附加广告信息<br>进行流量变现" },
        { img: "static/img/join/advantages9.png", title: "增值服务", content: "宗亲文化产品<br>宗族电子商务" },
      ],
      origin: "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;中国几十年间，快速提升了物质水平，人民慢慢回归追求精神水平，更有国家将家风传承、建立文化自信提升到了国家层面。在家族前辈、有识之士、有能精英的推进下，为了传承传统，建立家族纽带，凝聚血缘亲情，家族开始修建祠堂、续编族谱。",
      customers: [
        { name: "李**", phone: "136*****402", loaction: "广州", date: "09-08" },
        { name: "王**", phone: "157*****125", loaction: "东莞", date: "09-04" },
        { name: "赵**", phone: "163*****627", loaction: "清远", date: "08-25" },
        { name: "林**", phone: "156*****823", loaction: "广州", date: "08-23" },
        { name: "李**", phone: "135*****626", loaction: "佛山", date: "08-15" },
        { name: "刘**", phone: "132*****721", loaction: "广州", date: "08-06" },
        { name: "王**", phone: "128*****623", loaction: "茂名", date: "07-25" },
      ],
      origin2text: "族谱者，一族之志也，是一个氏族起源、发展的印记，就是宗族血脉承传的全过程，是后人去认识前辈祖先的主要依据。家谱蕴含着大量的人口学、民族学、民俗学、社会学、经济学、历史学、教育学人物传记以及地方史等具有重要研究价值的资料，对开展学术研究有重要价值，同时对海内外华人寻根认祖，增强民族凝聚力都有着重要意义。",
      xieyiContent: '<p style="line-height:20px">尊敬的用户，您选择使用“自动输入历史信息”功能，您同意本平台在法律允许的范围内，收集您输入的信息，您已知晓并同意在您浏览使用本平台建站服务搭建的页面时，我们会帮助您预先填写上次输入的历史信息，您的历史信息仅用于页面的预填充，且只有您点击提交按钮之后信息才会传递给商家使用。本平台非常重视用户信息的保护，详见<span style="color:blue"}>《隐私政策》</span></p>',
      docmHeight: document.documentElement.clientHeight,  //默认屏幕高度
      showHeight: document.documentElement.clientHeight,   //实时屏幕高度
      hideshow: true,  //显示或者隐藏footer
    };
  },
  computed: {
    areaData () {
      return this.$store.state.dict.cityData
    }
  },
  mounted () {
    // window.onresize监听页面高度的变化
    window.onresize = () => {
      return (() => {
        this.showHeight = document.body.clientHeight;
      })()
    }
  },
  //监听
  watch: {
    showHeight: function () {
      if (this.docmHeight > this.showHeight) {
        this.hideshow = false
      } else {
        this.hideshow = true
      }
    },
  },

  methods: {
    onSubmit (values) {
      console.log('submit', values);
    },


    onloaclfin1 (data) {
      this.showLocaSelecter1 = false;
      let area = '';
      let areaId = '';
      data.selectedOptions.forEach(item => {
        area = area + item.text + ','
        areaId = areaId + item.value + ','
      })
      this.form1.location = area.substr(0, area.length - 1)
      this.form1.locationID = areaId.substr(0, areaId.length - 1)
    },


    onloaclfin2 (data) {
      this.showLocaSelecter2 = false;
      let area = '';
      let areaId = '';
      data.selectedOptions.forEach(item => {
        area = area + item.text + ','
        areaId = areaId + item.value + ','
      })
      this.form3.location = area.substr(0, area.length - 1)
      this.form3.locationID = areaId.substr(0, areaId.length - 1)
    },

    //电话
    callPhone () {
      window.location.href = 'tel://13710156878'
    }
  }
};
</script>

<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
}

.popup-main {
  padding: 80px 25px 40px;
  border-radius: 10px;
}

.popup-title {
  text-align: center;
  font-weight: bold;
  font-size: 30px;
}

.tips {
  width: 80%;
  margin: 25px auto 0;
  display: flex;
  justify-content: center;
  align-items: center;
  justify-content: space-between;

  &-text {
    font-size: 22px;
    font-weight: 500;
    color: #1f1f1f;
  }
}

.com {
  font-size: 26px;
  font-weight: 500;
  color: #1f1f1f;
  margin-top: 20px;
}

.origin2 {
  @extend .customer;
  align-items: center;

  &-process {
    font-size: 28px;
    font-weight: 500;
    color: #1f1f1f;
    padding: 20px 0 20px;
  }

  &-text {
    padding: 10px 60px 30px;
    font-size: 25px;
    font-weight: 500;
    color: #565656;
    text-align: center;
  }
}

.container {
  width: 100vw;
  height: 100vh;
}

.main {
  margin: -120px auto 0;
  padding: 0 20px 0;
  background-color: rgb(248, 169, 116);
  padding-bottom: 250px;
}

.block1 {
  margin-top: -15px;
  background-color: #fff;
  border-radius: 8px;
  padding: 40px 40px 60px;
  box-shadow: 0px 6px 13px 0px rgba(176, 69, 15, 0.54);
}

.block4 {
  @extend .block1;
  text-align: center;
}

.block6 {
  @extend .block4;
}

.example {
  display: flex;
  margin-top: 20px;
}

.block2 {
  @extend .block1;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.slogan {
  width: 100%;
  background-image: url("/static/img/join/f-bg.png");
  background-size: cover;
  -webkit-background-size: cover;
  -o-background-size: cover;
  box-sizing: border-box;
  padding: 60px 40px 50px;
  font-size: 36px;
  font-weight: 500;
  margin-top: 20px;
  display: grid;
  grid-gap: 20px 0;
  grid-template-columns: repeat(3, 1fr);
  justify-items: center;
}

.block3 {
  @extend .block1;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.block5 {
  @extend .block4;
}

.revenuslist {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  justify-content: center;
  align-content: center;

  &-word {
    font-size: 36px;
    font-weight: bold;
    color: #101010;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
    text-align: center;
    padding: 0 40px 0;
  }
}

.info-main {
  padding: 20px 20px 20px;
  box-shadow: 0px 4px 13px 0px rgba(212, 212, 212, 0.98);
  border-radius: 10px;
  display: flex;
  align-items: center;
}

.functions {
  width: 100%;
  margin-top: 20px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 20px 10px;
}

.f-item {
  @extend .info-main;
  flex-direction: column;

  .f-title {
    margin-top: 10px;
    font-size: 24px;
    font-weight: bold;
  }

  .f-content {
    margin-top: 10px;
    font-size: 20px;
    text-align: center;
    white-space: pre-wrap;
  }
}

.footer {
  position: fixed;
  bottom: 0;
  width: 100vw;
  height: 110px;
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
}

.book {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 26px;
  color: #ff7941;
}

.callus {
  margin-left: 60px;
}

.form-item {
  padding: 20px 20px 20px;
  background-color: #f4f4f4;
  border-radius: 8px;
  transform-style: preserve-3d;
  margin-top: 20px;
}
.form-item:after {
  content: "*";
  color: red;
  position: absolute;
  top: 30px;
  left: 8px;
}

.form-input {
  background-color: #f4f4f4;
  font-weight: bold;
}

.checkbox {
  margin-top: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.xieyi {
  color: #b91318;
}

.origin {
  width: 100%;
  background-image: url("/static/img/join/origin-bg.png");
  background-size: cover;
  -webkit-background-size: cover;
  -o-background-size: cover;
  box-sizing: border-box;
  padding: 40px 40px 30px;
  text-align: left;
  font-size: 26px;
  font-weight: 500;
  color: #101010;
  line-height: 38px;
}

.customer {
  display: flex;
  flex-direction: column;
  margin-top: 20px;
  width: 100%;
  border: 1px solid #ababab;
  box-shadow: 0px 4px 13px 0px rgba(212, 212, 212, 0.98);
  border-radius: 10px;

  &-title {
    font-size: 30px;
    font-weight: bold;
    padding: 10px 0 10px;
  }

  &-con {
    height: 300px;
    overflow: hidden;
  }

  &-list {
    display: flex;
    flex-direction: column;
    animation: animate 5s linear infinite;

    &-item {
      display: flex;
      font-size: 36px;
      color: #7f7f7f;
    }
  }

  @keyframes animate {
    0% {
      transform: translateY(0%);
    }
    100% {
      transform: translateY(-100%);
    }
  }
}
</style>
